import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { throttle, get, memoize } from 'lodash';
import { i18n } from '@lt/localization';
import { getReviewsCount } from 'src/store/reviews/selectors';
import TopMenu from '../../components/Menu/TopMenu';
import { scrollToSectionAction } from '../../store/actions/view';
import { MENU_ITEMS_ID } from '../../constants';
import { getHotelRoulette } from '../../store/selectors/hotel';
import { DEFAULT_WINDOWS_TIMEOUT } from '../../../../constants';
import { getSearcherFetching } from '../../store/selectors/searcher';
import { getHotelExperiences } from '../../store/selectors/experiences';
import { getDefaultPrice } from '../../store/selectors/common';

const getMenuItems = memoize((isRoulette, reviewCount, hasExpiriences) => [
  ...(isRoulette
    ? []
    : [{ id: MENU_ITEMS_ID.GALLERY, label: i18n.t('hotel.topMenu.gallery') }]),
  { id: MENU_ITEMS_ID.SEARCHER, label: i18n.t('hotel.topMenu.searcher') },
  ...(isRoulette || !hasExpiriences
    ? []
    : [
        {
          id: MENU_ITEMS_ID.EXPERIENCE,
          label: i18n.t('hotel.topMenu.experience'),
        },
      ]),
  ...(isRoulette
    ? []
    : [
        { id: MENU_ITEMS_ID.HOTEL_FACTS, label: i18n.t('hotel.topMenu.facts') },
      ]),
  { id: MENU_ITEMS_ID.MAP, label: i18n.t('hotel.topMenu.map') },
  ...(isRoulette
    ? []
    : [
        {
          id: MENU_ITEMS_ID.FACILITIES,
          label: i18n.t('hotel.topMenu.facilities'),
        },
        {
          id: MENU_ITEMS_ID.REVIEWS,
          label: (
            <StyledLabel>
              {i18n.t('hotel.topMenu.reviews')}
              {reviewCount ? <sup>{reviewCount}</sup> : null}
            </StyledLabel>
          ),
        },
      ]),
]);

const StyledLabel = styled.span`
  display: flex;

  sup {
    margin-left: 3.5px;
    font-size: smaller;
  }
`;

const mapStateToProps = (state) => {
  const reviewCount = getReviewsCount(state);
  const isRoulette = getHotelRoulette(state);
  const hotelExperiences = getHotelExperiences(state);
  const hasExpiriences = hotelExperiences && hotelExperiences.length;

  return {
    minPrice: getDefaultPrice(state),
    fetching: getSearcherFetching(state),
    menuItems: getMenuItems(isRoulette, reviewCount, hasExpiriences),
  };
};

const mapDispatchToProps = (dispatch) => ({
  scrollToSection: (section) => dispatch(scrollToSectionAction(section)),
});

class TopMenuContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    // по умолчанию активный первый пункт меню
    const active = get(props, ['menuItems', '0', 'id']);

    this.state = {
      active,
    };

    this.handleMenuClick = this.handleMenuClick.bind(this);
    this.handleShowToursClick = this.handleShowToursClick.bind(this);
    this.handleScroll = throttle(
      this.handleScroll,
      DEFAULT_WINDOWS_TIMEOUT / 4,
    ).bind(this);
  }

  componentDidMount() {
    const { menuItems } = this.props;
    this.ELEMENTS = Object.values(menuItems).map(({ id }) =>
      document.getElementById(id),
    );
    this.offset = window.pageYOffset;
    document.addEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const { pageYOffset } = window;
    const direction = pageYOffset > this.offset ? 'down' : 'up';
    this.offset = pageYOffset;
    const req =
      pageYOffset + document.body.clientHeight / (direction === 'down' ? 2 : 6);

    const active = this.ELEMENTS.reduce(
      (res, current) => (current.offsetTop <= req ? current.id : res),
      null,
    );
    if (active) {
      this.setState({ active });
    }
  }

  handleMenuClick(id) {
    document.removeEventListener('scroll', this.handleScroll);
    const { scrollToSection } = this.props;
    scrollToSection(id);
    this.setState({ active: id });
    setTimeout(
      () => document.addEventListener('scroll', this.handleScroll),
      DEFAULT_WINDOWS_TIMEOUT,
    );
  }

  handleShowToursClick() {
    this.handleMenuClick(MENU_ITEMS_ID.SEARCHER);
  }

  render() {
    const { active } = this.state;
    return (
      <TopMenu
        {...this.props}
        active={active}
        onMenuItemClicked={this.handleMenuClick}
        onShowToursClicked={this.handleShowToursClick}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopMenuContainer);
